import { create } from 'zustand';
import type { Profile } from '../types/profile';

/**
 * The signed-in company profile. Written by whoAmI (services/authService) and
 * the account mutations; read by the session hook, the shell and logging.
 * Server data for everything else lives in TanStack Query, not here.
 */
interface ProfileState {
  activeProfile: Profile | null;
  setActiveProfile: (profile: Profile | null) => void;
}

export const useProfileStore = create<ProfileState>((set) => ({
  activeProfile: null,
  setActiveProfile: (activeProfile) => set({ activeProfile }),
}));
